/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/whats_app/waba/creative_optimization_settings" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { wabaCreativeOptimizationSettings } from "./constants";
import type { WabaCreativeOptimizationSettingsResult, WabaCreativeOptimizationSettingsResultError } from "./types";
import { isWabaCreativeOptimizationSettingsResult } from "./validators";

export const getWabaCreativeOptimizationSettings = reactQueryFetcherAdapter(
  wabaCreativeOptimizationSettings,
  createGetFetcherFunctionWithShadowError<WabaCreativeOptimizationSettingsResultError>()(
    async (
      signal: AbortSignal,
      appGroupId: string,
      messagingServiceId: string
    ): Promise<WabaCreativeOptimizationSettingsResult> => {
      return await fetch(
        `/engagement/${appGroupId}/whats_app/waba/creative_optimization_settings?messaging_service_id=${messagingServiceId}`,
        "GET",
        undefined,
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isWabaCreativeOptimizationSettingsResult
);
